import { Text, View, Font } from '@react-pdf/renderer';
import parse, { domToReact } from 'html-react-parser';

import RobotoRegular from "../../fonts/Roboto-Regular.ttf";
import RobotoBold from "../../fonts/Roboto-Bold.ttf";
import RobotoItalic from "../../fonts/Roboto-Italic.ttf";
import RobotoBoldItalic from "../../fonts/Roboto-BoldItalic.ttf";

// Enregistre la famille Roboto avec toutes les variantes nécessaires
Font.register({
    family: 'Roboto',
    fonts: [
        { src: RobotoRegular, fontWeight: 'normal', fontStyle: 'normal' },
        { src: RobotoBold, fontWeight: 'bold', fontStyle: 'normal' },
        { src: RobotoItalic, fontWeight: 'normal', fontStyle: 'italic' },
        { src: RobotoBoldItalic, fontWeight: 'bold', fontStyle: 'italic' },
    ],
});

// Conserve l'ancien alias utilisé ailleurs dans le projet
Font.register({
    family: 'RobotoBold',
    format: 'truetype',
    src: RobotoBold,
});

const CompteRenduHtml = ({ html }) => {

    const options = {
        replace: ({ name, children }) => {
            if (name === 'h1') {
                return <Text style={{ fontFamily: 'Roboto', fontSize: 32, marginBottom: 10 }}>{domToReact(children, options)}</Text>;
            }
            if (name === 'h2') {
                return <Text style={{ fontFamily: 'Roboto', fontSize: 24, marginBottom: 10 }}>{domToReact(children, options)}</Text>;
            }
            if (name === 'h3' || name === 'h4') {
                return <Text style={{ fontFamily: 'Roboto', fontSize: 18, marginBottom: 10 }}>{domToReact(children, options)}</Text>;
            }
            if (name === 'p') {
                return <Text style={{ fontFamily: 'Roboto', fontSize: 12, marginBottom: 10 }}>{domToReact(children, options)}</Text>;
            }
            if (name === 'strong' || name === 'b') {
                return <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>{domToReact(children, options)}</Text>;
            }
            if (name === 'em' || name === 'i') {
                return <Text style={{ fontFamily: 'Roboto', fontStyle: 'italic' }}>{domToReact(children, options)}</Text>;
            }
            if (name === 'ul') {
                return <View style={{ fontFamily: 'Roboto', fontSize: 12, paddingLeft: 20, marginBottom: 10 }}>{domToReact(children, options)}</View>;
            }
            if (name === 'li') {
                return (
                    <View style={{ display: 'flex', width: '100%', marginBottom: 5 }}>
                        <Text style={{ fontFamily: 'Roboto', textIndent: -6, paddingLeft: 6 }}>• {domToReact(children, options)}</Text>
                    </View>
                );
            }
            return undefined;
        }
    };

    const renderHtml = () => {
        return parse(html || '', options);
    }

    return (
        <View>
            {renderHtml()}
        </View>
    );
}

export default CompteRenduHtml;